import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {
  CompanySubset,
  DeleteCompanyDataEntry,
  CompanyAPIService,
} from 'app/api/company.api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { parseErrorMessage } from 'app/utils/callstate';
import { AppState } from 'app/reducers';
import { Store, select } from '@ngrx/store';
import { CompanyActions } from 'app/main/company/actions';
import { CompanySelectors } from 'app/main/company/selectors';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-DeleteCompanyDialog',
  templateUrl: './DeleteCompanyDialog.component.html',
  styleUrls: ['./DeleteCompanyDialog.component.scss'],
})
export class DeleteCompanyDialogComponent implements OnInit, OnDestroy {
  deleteForm: DeleteCompanyDataEntry = {} as DeleteCompanyDataEntry;
  errorMessage: string;
  deleteResponse = { status: '', message: '', filePath: '' };
  isDeleting = false;
  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    public dialogRef: MatDialogRef<DeleteCompanyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { company: CompanySubset },
    protected store: Store<AppState>,
    private companyApiService: CompanyAPIService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    // this.loading$ = this.store.pipe(
    //   select(CompanySelectors.selectCompanyLoading)
    // );
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  submit(): void {
    this.deleteForm.id = this.data.company.id;
      // tslint:disable-next-line:prefer-const
    let { dataType, id } = this.deleteForm;
    const Analytics = 'anna';
    this.isDeleting = true;
    // this.store.dispatch(
    //   CompanyActions.companyDeleteRequested({
    //     input: {
    //       id,
    //       dataType,
    //     } as DeleteCompanyDataEntry,
    //   })
    // );

    if ( dataType === 'accounting')  {
        dataType = 'analytics';
        console.log(dataType);
        this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

        dataType = 'plan';
        console.log(dataType);
        this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

        dataType = 'journal';
        console.log(dataType);
        this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

        dataType = 'balance';
        console.log(dataType);
        this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

        dataType = 'accounting';
        console.log(dataType);
        this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

        dataType = 'cube';
        console.log(dataType);
        this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

        dataType = 'rules';
        console.log(dataType);
        this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

        dataType = 'file-upload';
        console.log(dataType);
        this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });
    } else if ( dataType === 'payroll'){
    dataType = 'payroll';
    console.log(dataType);
    this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

    dataType = 'payroll-rule';
    console.log(dataType);
    this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });

    dataType = 'payroll-extra';
    console.log(dataType);
    this.companyApiService.DeleteCompanyData({ dataType, id })
      .toPromise()
      .then(response => {
        this.isDeleting = false;
        console.log('Delete Respone: ', response);
        this.dialogRef.close(response);
      })
      .catch(err => {
        this.errorMessage = parseErrorMessage(err);
        this.isDeleting = false;
        console.error('Failed to delete entry', this.errorMessage);
      });
    }
  }
}
